import { TypographyStylesProvider, Code, Image } from "@mantine/core";
import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import {
  IconApps,
  IconInfoCircle,
  IconPlugConnected,
  IconUsers,
} from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const NOSTR_GET_PUBLIC_KEY_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Each of your Rizful Node nodes has a Nostr public key that can uniquely
      identify you on the decentralized web.
    </p>

    <p>1. Use the Node Info button. </p>

    <DocsButton
      ariaLabel="node info"
      text="Node Info"
      leftSection={<IconInfoCircle />}
    />
    <p>2. Copy your Nostr public key. </p>
    <SimpleImage
      h={500}
      src="docs_images/copy-your-nostr-public-key-from-here.png"
    />
  </TypographyStylesProvider>
);
